import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import productApi from 'src/api/product'

export const fetchStore = createAsyncThunk(
  'store/fetchStore',
  async () => {
    const response = await productApi.getAllListOfStore()
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewParams: null,
  reload: false,
  storeList: [],
  loading: false,
}

const slice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    openModal(state) {
      state.isModalOpen = true
    },
    closeModal(state) {
      state.isModalOpen = false
      state.modalViewParams = null
    },
    setModalViewParams(state, action) {
      state.modalViewParams = action.payload
    },
    setReload(state, action) {
      state.reload = action.payload
    },
  },
  extraReducers: {
    [fetchStore.pending]: (state) => {
      state.loading = true
    },
    [fetchStore.fulfilled]: (state, action) => {
      state.storeList = action.payload
      state.loading = false
    },
    [fetchStore.rejected]: (state) => {
      state.loading = false
    },
  },
})

export const { openModal, closeModal, setModalViewParams, setReload } = slice.actions
export const reducer = slice.reducer
